// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--2aBFQ","title":"a10a3f92e9--title--1xMSG","list":"a10a3f92e9--list--2bLMl","item":"a10a3f92e9--item--19C7C"};